import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, CheckCircle2, ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import { adminApi } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [devUrl, setDevUrl] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true); setError("");
    try {
      const { data } = await adminApi.forgotPassword(email.trim().toLowerCase(), "fr");
      setDone(true);
      if (data && data.dev_reset_url) {
        setDevUrl(data.dev_reset_url);
      }
    } catch (err) {
      setError(err?.response?.data?.detail || "Erreur, réessayez.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="forgot-password-page">
      <Header />
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-white border border-primary/15 rounded-sm shadow-lg p-8">
          <Link to="/admin/login" className="inline-flex items-center gap-1 text-xs text-foreground/60 hover:text-primary mb-4">
            <ArrowLeft size={12} /> Retour à la connexion
          </Link>
          <h1 className="font-display text-2xl font-semibold text-primary mb-1">Mot de passe oublié</h1>
          <p className="text-sm text-foreground/60 mb-6">
            Entrez l'email associé à votre compte ou votre email de récupération. Un lien de réinitialisation vous sera envoyé (valable 30 minutes).
          </p>

          {done ? (
            <div data-testid="forgot-success">
              <div className="flex items-start gap-3 bg-[#D1FAE5] border border-[#A7F3D0] text-[#065F46] px-3 py-3 rounded-sm mb-4">
                <CheckCircle2 size={16} className="shrink-0 mt-0.5" />
                <div className="text-sm leading-snug">
                  Si un compte existe pour <strong>{email}</strong>, un lien de réinitialisation a été envoyé à l'email de récupération associé.
                </div>
              </div>
              {devUrl && (
                <div className="bg-[#FEF3C7] border border-[#FDE68A] px-3 py-3 rounded-sm text-xs" data-testid="dev-reset-url">
                  <div className="font-mono uppercase text-[10px] tracking-wider text-[#92400E] mb-1">⚠ Mode DEV (clé Resend absente)</div>
                  <div className="text-[#92400E] break-all">
                    Lien de test : <a href={devUrl} className="underline font-mono">{devUrl}</a>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <label className="block">
                <span className="block font-mono text-[10px] uppercase tracking-[0.2em] text-foreground/60 mb-1">Email</span>
                <div className="flex items-center gap-2 border border-primary/20 rounded-sm px-3 focus-within:border-primary transition-colors bg-white">
                  <Mail size={14} className="text-foreground/40" />
                  <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                         placeholder="vous@exemple.cm"
                         className="flex-1 bg-transparent text-sm py-2.5 outline-none"
                         data-testid="forgot-email-input" />
                </div>
              </label>
              {error && <div className="text-xs text-[#991B1B] bg-[#FEE2E2] border border-[#FECACA] px-3 py-2 rounded-sm">{error}</div>}
              <button type="submit" disabled={submitting}
                      className="w-full inline-flex items-center justify-center gap-2 bg-primary text-white px-5 py-3 rounded-sm text-sm font-medium hover:bg-primary-light transition-colors disabled:opacity-60"
                      data-testid="forgot-submit-btn">
                {submitting ? <Loader2 size={14} className="animate-spin" /> : null}
                Envoyer le lien de réinitialisation
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
